import { ThemeEvents } from '@theme/events';

// These are the same two mattress products configured in the delivery upsell rule.
const mattressHandles = new Set(['geli-sova-mattress', 'geli-organic-by-essentia']);

class DeliveryEligibility extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.formId);
    this.controls = this.form?.querySelector('[data-delivery-controls]');
    this.status = this.querySelector('[data-delivery-status]');
    if (!this.form || !this.controls || !this.status) return;
    this.form.addEventListener('submit', this.handleSubmit, true);
    document.addEventListener(ThemeEvents.cartUpdate, this.checkCart);
    window.addEventListener('pageshow', this.checkCart);
    this.checkCart();
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit, true);
    document.removeEventListener(ThemeEvents.cartUpdate, this.checkCart);
    window.removeEventListener('pageshow', this.checkCart);
    this.request?.abort();
  }

  checkCart = async () => {
    this.request?.abort();
    const request = new AbortController();
    this.request = request;
    this.controls.disabled = true;
    try {
      const response = await fetch(`${Shopify.routes.root}cart.js`, { signal: request.signal, cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
      const eligible = cart.items.some((item) => item.quantity > 0 && mattressHandles.has(item.handle));
      const deliveryProductId = Number(this.form.closest('product-form-component').dataset.productId);
      const alreadyAdded = cart.items.some((item) => item.quantity > 0 && item.product_id === deliveryProductId);
      const canAdd = eligible && !alreadyAdded;
      this.controls.disabled = !canAdd;
      this.status.hidden = canAdd || alreadyAdded;
      this.status.textContent = alreadyAdded
        ? ''
        : eligible ? '' : 'Add a Geli Sova or Geli Organic mattress to your cart before adding White Glove Delivery.';
      return canAdd;
    } catch (error) {
      if (error.name === 'AbortError') return false;
      this.status.hidden = false;
      this.status.textContent = 'We couldn’t check your cart. Refresh the page to check mattress eligibility.';
      return false;
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.submitting) return;
    this.submitting = true;
    try {
      // Recheck at submission so an old page cannot rely on stale eligibility.
      if (await this.checkCart()) {
        // Horizon delegates submits in document capture. This delivery form omits
        // on:submit so only this verified handoff invokes its native handler.
        this.form.closest('product-form-component').handleSubmit(event);
      }
    } finally {
      this.submitting = false;
    }
  };
}

if (!customElements.get('gs-delivery-eligibility')) {
  customElements.define('gs-delivery-eligibility', DeliveryEligibility);
}
